import { Meteor } from 'meteor/meteor'

import { dispatch } from '../store'

import { SET_COMPETENCE } from '../reducers/competences'

export const fetchCompetences = async (backOffice = false) => {
  const competences = await Meteor.promise('getCompetences', backOffice)

  dispatch({
    type: SET_COMPETENCE,
    payload: competences,
  })
}
